import { GSInfoGroup, GSImage, GSButton } from "golfstatus_react_components";
import { getV3Date } from "../../../helpers/Dates";

const TournamentMessageTournamentLineItem = (props) => {
  const { tournament } = props;

  const getStartDate = () => {
    if (!tournament?.startAt) {
      return "No date selected";
    }
    if (tournament?.numberOfRounds > 1) {
      return `${getV3Date(tournament?.startAt)} - ${getV3Date(
        tournament?.endAt
      )}`;
    }
    return getV3Date(tournament?.startAt);
  };

  const getStateColor = (state) => {
    switch (state) {
      case "final":
        return "black";
      case "active":
        return "green";
      case "draft":
        return "light-grey";
      default:
        return "";
    }
  };

  const image = {
    fit: "hide-mobile",
    sections: [
      {
        sectionItems: [
          {
            type: "primary full-width",
            value: <GSImage size="medium wide" src={tournament?.logo} />,
          },
        ],
      },
    ],
  };

  const tournamentDetails = {
    fit: "stretch",
    sections: [
      {
        sectionItems: [
          {
            type: "primary",
            value: tournament?.name,
            sectionItemStyle: { whiteSpace: "normal" },
          },
          {
            type: "secondary no-wrap",
            value: tournament?.organization?.name,
          },
        ],
      },
      {
        sectionItems: [
          {
            type: "secondary no-wrap",
            value: getStartDate(),
          },
          {
            type: "secondary",
            value: tournament?.facility?.name ?? "No course selected",
          },
        ],
      },
      {
        sectionItems: [
          {
            type: "primary full-width",
            value: (
              <GSButton
                type={`secondary status pill ${getStateColor(
                  tournament?.state
                )}`}
                title={
                  tournament?.state !== "final" ? tournament?.state : "complete"
                }
              />
            ),
          },
        ],
      },
    ],
  };

  return (
    <tournament-message-tournament-line-item>
      <GSInfoGroup dataGroups={[image, tournamentDetails]} />
    </tournament-message-tournament-line-item>
  );
};

export default TournamentMessageTournamentLineItem;
